module.exports = __webpack_public_path__ + "fedfd78cd4a5e2b386888f79136757c5.png";